// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3j3V0","filesListContainer":"PosDisputesFiles_filesListContainer__2xlYI","filesButton":"PosDisputesFiles_filesButton__292bB"};